import { AdminRewardsSummaryItem } from '../../../../rewards/models/rewards-v2.models';
import {
  formatRewardsTableCurrency,
  getRuleAmount as getTableRuleAmount,
  getRuleCount as getTableRuleCount,
  ruleAmountColumnHeader,
  ruleCountColumnHeader,
} from '../../../../rewards/utils/rewards-table-display.util';

export function formatSummaryCurrency(amount: number | string): string {
  return formatRewardsTableCurrency(amount);
}

export function getEmployeeInitials(name: string): string {
  if (!name?.trim()) {
    return '?';
  }
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export function getRuleCount(item: AdminRewardsSummaryItem, ruleId: string): string {
  return getTableRuleCount(item, ruleId);
}

export function getRuleAmount(item: AdminRewardsSummaryItem, ruleId: string): string {
  return getTableRuleAmount(item, ruleId);
}

export { ruleCountColumnHeader, ruleAmountColumnHeader };
